<template>
  <div
    class="field-control eds-input"
    :class="[`input-${state}`, fieldControlClass]"
    :style="fieldControlStyle"
  >
    <div
      v-if="$slots.prepend"
      class="input-prepend eds-input-addon input-gray"
      :class="prependClass"
      :style="prependStyle"
    >
      <span
        class="input-addon-content"
        :class="[
          {
            'input-addon-text': prependType === 'text',
            'input-icon': prependType === 'icon',
          },
          prependTextClass,
        ]"
        :style="prependTextStyle"
      >
        <slot name="prepend" />
      </span>
    </div>
    <input
      v-bind="$attrs"
      v-focus="autoFocus"
      :value="modelValue"
      :type="inputType"
      class="input-element"
      :class="inputClass"
      :style="inputStyle"
      :pattern="pattern"
      :min="min"
      :disabled="disabled"
      @input="$emit('update:modelValue', ($event.target as any)?.value)"
    />
    <div
      v-if="$slots.append"
      class="input-append eds-input-addon input-gray"
      :class="appendClass"
      :style="appendStyle"
    >
      <span
        class="input-addon-content"
        :class="[
          {
            'input-addon-text': appendType === 'text',
            'input-icon': appendType === 'icon',
          },
          appendTextClass,
        ]"
        :style="appendTextStyle"
      >
        <slot name="append" />
      </span>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Textbox',
    inheritAttrs: false,
    emits: ['update:modelValue'],
    directives: {
      focus: {
        // provides autofocus of input field
        mounted(el, binding) {
          if (binding.value) el.focus();
        },
      },
    },
    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      modelValue: {
        type: [String, Number],
        required: false,
        default: '',
      },
      state: {
        type: String,
        required: false,
        default: 'basic',
        validator: (value: string) => {
          return ['basic', 'warning', 'error'].includes(value);
        },
      },
      autoFocus: {
        type: Boolean,
        required: false,
        default: false,
      },
      inputType: {
        type: String,
        required: false,
        default: 'text',
        validator: (value: string) => {
          return ['text', 'password', 'email', 'number', 'file'].includes(
            value
          );
        },
      },
      inputClass: {
        type: String,
        required: false,
        default: '',
      },
      inputStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      fieldControlClass: {
        type: String,
        required: false,
        default: '',
      },
      fieldControlStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      pattern: {
        type: String,
        required: false,
        default: '',
      },
      min: {
        type: Number,
        required: false,
        default: 1,
      },
      prependClass: {
        type: String,
        required: false,
        default: '',
      },
      prependStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      prependType: {
        type: String,
        required: false,
        default: 'text',
        validator: (value: string) => {
          return ['text', 'icon'].includes(value);
        },
      },
      prependTextClass: {
        type: String,
        required: false,
        default: '',
      },
      prependTextStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      appendClass: {
        type: String,
        required: false,
        default: '',
      },
      appendStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      appendType: {
        type: String,
        required: false,
        default: 'text',
        validator: (value: string) => {
          return ['text', 'icon'].includes(value);
        },
      },
      appendTextClass: {
        type: String,
        required: false,
        default: '',
      },
      appendTextStyle: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
  });
</script>
